module.exports = __webpack_public_path__ + "static/media/em-85.b51e8d81.png";